import React from 'react'

const XIcon = ({
  width = 60,
  height = 60,
  responsive = true,
  ...props
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      {...svgAttributes}
      {...props}
    >
      <line xmlns="http://www.w3.org/2000/svg" x1="18" y1="6" x2="6" y2="18"/>
      <line xmlns="http://www.w3.org/2000/svg" x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  )
}

export default XIcon